// gamvartskaiciuokle
$(document).ready(function () {
	if (typeof (gvsParams) !== 'undefined') {
		window.gvsCalculator.init();
	} else {
		console.log('gvsParams' + typeof (gvsParams));
	}
});

window.gvsCalculator = {
	$container: null,
	$slideBlock: null,
	$resultsBlock: null,

	consumption: 30,
	usage: null,
	power: null,

	FIXED: 12,

	results: {
		resStandart: 0,
		resHome: 0,
		resHomePlus: 0,
		resKwh: 0,
		resKw: 0,
		resKwhKw: 0
	},

	rangeValues: {
		min: 0,
		max: 100
	},

	init: function () {
		var self = this;

		self.$container = $('#gvs_calculator');
		self.$slideBlock = self.$container.find('.slider_holder');
		self.$resultsBlock = self.$container.find('.results_holder');

		self.$container.show();

		self.initSliders();
		self.initFields(self.$container);
	},

	initFields: function ($obj) {
		var self = this;

		var $usage = $obj.find('#usage');
		var $power = $obj.find('#power');

		$usage.val(self.usage);
		$usage.keyup(function () {
			$(this).val($(this).val().replace(/[^\d.]/g, ''));
			self.usage = parseFloat(this.value) || 0;

			self.calcResults();
		});

		$power.val(self.power);
		$power.keyup(function () {
			$(this).val($(this).val().replace(/[^\d.]/g, ''));
			self.power = parseFloat(this.value) || 0;

			self.calcResults();
		});
	},

	initSliders: function () {
		var self = this;

		if (!$.fn.slider || self.$slideBlock.length === 0) {
			return;
		}

		var $slider = self.$slideBlock.find('.__callSlider');

		self.$slideBlock.find('.vals_left').text(self.rangeValues.min + "%");
		self.$slideBlock.find('.vals_right').text(self.rangeValues.max + "%");

		$slider.slider({
			range: 'max',
			min: self.rangeValues.min,
			max: self.rangeValues.max,
			value: self.consumption,
			create: function (e, ui) {
				// Show initial value in slider handle and external div
				$slider.find('.ui-slider-handle').html('<span class="value">' + self.consumption + '%</span>');
				$('#external-slider-value').text(self.consumption + '%');
			},
			slide: function (e, ui) {
				// Update value in slider handle
				$slider.find('.ui-slider-handle .value').text(ui.value + "%");
				self.consumption = parseInt(ui.value);
				// Update value in external div
				$('#external-slider-value').text(ui.value + '%');
			},
			stop: function () {
				self.calcResults();
			}
		});
	},

	calcResults: function () {
		var self = this;

		self.results.resStandart = self.getStandartRes();
		self.results.resHome = self.getHomeRes();
		self.results.resHomePlus = self.getHomePlusRes();
		self.results.resKwh = self.getKwhRes();
		self.results.resKw = self.getKwRes();
		self.results.resKwhKw = self.getKwhKwRes();
		self.viewResults();

		if (self.usage != null && self.usage > 0 && self.power != null && self.power > 0) {
			self.$resultsBlock.show();
		}
	},

	viewResults: function () {
		var self = this;

		self.$resultsBlock.find('#resStandart').text(self.results.resStandart);
		self.$resultsBlock.find('#resHome').text(self.results.resHome);
		self.$resultsBlock.find('#resHomePlus').text(self.results.resHomePlus);
		self.$resultsBlock.find('#resKwh').text(self.results.resKwh);
		self.$resultsBlock.find('#resKw').text(self.results.resKw);
		self.$resultsBlock.find('#resKwhKw').text(self.results.resKwhKw);
	},

	getStandartRes: function () {
		var self = this;

		var kof = parseFloat(gvsParams.standartinio_plano_kof);
		var formula = (self.usage - self.power * 1000 > 0) ? (self.usage - self.power * 1000) : 0;

		return self.round(kof * formula, 2);
	},

	getHomeRes: function () {
		var self = this;

		var kof1 = parseFloat(gvsParams.namai_plano_kof);
		var kof2 = parseFloat(gvsParams.namai_plano_dgk);
		var formula = (self.usage - self.power * 1000 > 0) ? (self.usage - self.power * 1000) : 0;

		return self.round(kof1 * self.FIXED + kof2 * formula, 2);
	},

	getHomePlusRes: function () {
		var self = this;

		var kof1 = parseFloat(gvsParams.namai_plus_plano_kof);
		var kof2 = parseFloat(gvsParams.namai_plus_plano_dgk);
		var formula = (self.usage - self.power * 1000 > 0) ? (self.usage - self.power * 1000) : 0;

		return self.round(kof1 * self.FIXED + kof2 * formula, 2);
	},

	getKwhRes: function () {
		var self = this;

		var kof1 = parseFloat(gvsParams.atsiskaitymas_kwh_kof);

		// excel formula = IF(C3>C6;C6-C10;IF(C3>C10;C3-C10;0))
		var C3 = self.usage;
		var C6 = self.power * 1000;
		var C10 = (self.power * 1000 * self.consumption / 100);

		var formula = (C3 > C6) ? (C6 - C10) : (C3 > C10) ? (C3 - C10) : 0;

		return self.round(kof1 * formula, 2);
	},

	getKwRes: function () {
		var self = this;

		var kof1 = parseFloat(gvsParams.atsiskaitymas_galia_kof);
		var formula = self.power;

		return self.round(formula * self.FIXED * kof1, 2);
	},

	getKwhKwRes: function () {
		var self = this;

		var kof1 = parseFloat(gvsParams.atsiskaitymas_mix_kof1);
		var kof2 = parseFloat(gvsParams.atsiskaitymas_mix_kof2);

		// excel formula = IF(C3>C6;C6-C10;IF(C3>C10;C3-C10;0))
		var C3 = self.usage;
		var C6 = self.power * 1000;
		var C10 = (self.power * 1000 * self.consumption / 100);

		var formula1 = (C3 > C6) ? (C6 - C10) : (C3 > C10) ? (C3 - C10) : 0;
		var formula2 = self.power;

		return self.round(formula1 * kof1 + formula2 * kof2 * self.FIXED, 2);
	},

	round: function (value) {
		var precision = (arguments[1]) ? parseInt(arguments[1]) : 2;
		var factor = Math.pow(10, precision);
		var sum = Math.round(value * factor) / factor;

		return sum.toFixed(2);
	}
};